import { useEffect, useState } from "react";
import { api, hasBackend } from "@/lib/api";

let cache = null;

export function useProjects() {
  const [projects, setProjects] = useState(cache || []);
  const [loading, setLoading] = useState(!cache);
  const [error, setError] = useState(false);

  useEffect(() => {
    let alive = true;
    if (!hasBackend) {
      setLoading(false);
      setError(true);
      return () => { alive = false; };
    }
    api
      .get("/projects")
      .then((r) => {
        const list = Array.isArray(r.data) ? r.data : [];
        cache = list;
        if (alive) setProjects(list);
      })
      .catch(() => { if (alive) setError(true); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  return { projects, loading, error };
}

export function usePageMeta(title, description) {
  useEffect(() => {
    if (title) document.title = title;
    const m = document.querySelector('meta[name="description"]');
    if (m && description) m.setAttribute("content", description);
  }, [title, description]);
}
